"use client";

import React from "react";
import { ChevronUp, ChevronDown, ArrowUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface SortToggleProps {
  col: string;
  sortConfig: { col: string | null; order: 'asc' | 'desc' };
  setSortConfig: React.Dispatch<React.SetStateAction<{ col: string | null; order: 'asc' | 'desc' }>>;
}

export const SortToggle = ({ col, sortConfig, setSortConfig }: SortToggleProps) => {
  const isActive = sortConfig.col === col;
  const labelMap: Record<string, string> = {
    member_id: 'ID',
    name: 'NAME',
    gender: 'GENDER BY AI',
    role: 'ROLE',
    locality: 'CITY/LOCALITY',
    state: 'STATE',
    country: 'COUNTRY',
    region: 'REGION',
    chapter: 'CHAPTER',
    cluster: 'COMMUNITY',
    nearest_cluster: 'NEAREST COMMUNITY',
    chapter_eligible: 'ELIGIBILITY',
    program_journey: 'PROGRAM JOURNEY',
    membership_journey: 'MEMBERSHIP JOURNEY',
    id_discord: 'DISCORD ID',
    actual_site_name: 'PROMETRIC CENTER',
    closest_center_dist_miles: 'CLOSEST DIST',
    exam_center_match: 'EXAM MATCH'
  };

  return (
    <button
      onClick={() => setSortConfig(prev => ({
        col,
        order: prev.col === col && prev.order === 'asc' ? 'desc' : 'asc'
      }))}
      className={cn(
        "p-0.5 rounded hover:bg-white/10 transition-colors uppercase flex items-center gap-1 group/sort",
        isActive ? "text-white" : "text-white/40"
      )}
    >
      <span className="whitespace-nowrap">{labelMap[col] || col}</span>
      {isActive ? (
        sortConfig.order === 'asc' ? <ChevronUp className="w-2.5 h-2.5" /> : <ChevronDown className="w-2.5 h-2.5" />
      ) : (
        <ArrowUpDown className="w-2.5 h-2.5 opacity-0 group-hover/sort:opacity-100 transition-opacity" />
      )}
    </button>
  );
};
